import { Dispatch, SetStateAction, useState } from "react";

type Toggle = [boolean, () => void, Dispatch<SetStateAction<boolean>>];

export default function useToggle(defaultValue = false): Toggle {
  const [value, setValue] = useState(defaultValue);
  const toggle = () => setValue((x) => !x);
  return [value, toggle, setValue];
}
